import axios from "axios";
import {getLocalData} from "./StorageServices";
import getEnv from "../helpers/common/getEnv";

const _getAppVersion = () => {
    const app = getLocalData('app');

    return app ? app.version : '1.0.0';
};

class APIService {
    constructor(baseURL) {
        const _baseURL = baseURL || getEnv('baseAPIUrl');

        this.api = axios.create({
            baseURL: _baseURL,
            timeout: 15000,
        });
    }

    makeRequest(args) {
        const _headers = args.headers ? args.headers : {};

        const defaultHeaders = {
            'X-App-Version': _getAppVersion(),
        };

        args = {
            ...args,
            headers: {
                ...defaultHeaders,
                ..._headers
            }
        };

        return this.api(args)
            .then(response => {
                return Promise.resolve(response.data);
            });
    }
}

export const APIServiceExtend = (baseURL) => {
    return new APIService(baseURL);
};

export default new APIService();



// WEBPACK FOOTER //
// ./src/services/APIServices.js